import { assetsPath } from "../../utils";

const landingPage = [
  {
    image: `${assetsPath('phuket-laguna-park-2')}/images/destination/landing-page/1.jpg`
  },
  {
    image: `${assetsPath('phuket-laguna-park-2')}/images/destination/landing-page/2.jpg`
  },
  {
    image: `${assetsPath('phuket-laguna-park-2')}/images/destination/landing-page/3.jpg`
  },
  {
    image: `${assetsPath('phuket-laguna-park-2')}/images/destination/landing-page/4.jpg`
  },
  {
    image: `${assetsPath('phuket-laguna-park-2')}/images/destination/landing-page/5.jpg`
  }
];

const map = [
  {
    value: "country",
    name: "Country Map",
    image: {
      en: `${assetsPath('phuket-laguna-park-2')}/images/destination/country-map/map-country_en.png`,
      cn: `${assetsPath('phuket-laguna-park-2')}/images/destination/country-map/map-country_cn.png`,
      ru: `${assetsPath('phuket-laguna-park-2')}/images/destination/country-map/map-country_ru.png`,
    }
  },
  {
    value: "city",
    name: "City Map",
    images: [
      {
        name: "Airport",
        icon: `${assetsPath()}/images/icon/map-icon-01.png`,
        image: `${assetsPath('phuket-laguna-park-2')}/images/destination/city-map/airport.png`
      },
      {
        name: "Beaches",
        icon: `${assetsPath()}/images/icon/map-icon-02.png`,
        image: `${assetsPath('phuket-laguna-park-2')}/images/destination/city-map/beach.png`
      },
      {
        name: "Islands",
        icon: `${assetsPath()}/images/icon/map-icon-03.png`,
        image: `${assetsPath('phuket-laguna-park-2')}/images/destination/city-map/island.png`
      },
      {
        name: "Schools",
        icon: `${assetsPath()}/images/icon/map-icon-05.png`,
        image: `${assetsPath('phuket-laguna-park-2')}/images/destination/city-map/school.png`
      },
      {
        name: "Tourist Attractions",
        icon: `${assetsPath()}/images/icon/map-icon-06.png`,
        image: `${assetsPath('phuket-laguna-park-2')}/images/destination/city-map/tourist-attraction.png`
      }
    ]
  },
  {
    value: "project",
    name: "Project Map",
    images: [
      {
        name: "Hotels & Resorts",
        icon: `${assetsPath()}/images/icon/project-icon-01.png`,
        svg: null
      },
      {
        name: "Restaurants",
        icon: `${assetsPath()}/images/icon/project-icon-02.png`,
        svg: null
      },
      {
        name: "Spas",
        icon: `${assetsPath()}/images/icon/project-icon-03.png`,
        svg: null
      },
      {
        name: "Galleries & Shopping",
        icon: `${assetsPath()}/images/icon/project-icon-04.png`,
        svg: null
      },
      {
        name: "Shuttle Bus",
        icon: `${assetsPath()}/images/icon/project-icon-05.png`,
        svg: null
      },
      {
        name: "Shuttle Boat",
        icon: `${assetsPath()}/images/icon/project-icon-06.png`,
        svg: null
      }
    ]
  }
];

const content = {
  title: "Destination",
  description: {
    en:
      "<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travelers to visit from around the world.<br><br>Reaching Phuket is easy with direct flights from main cities around the world.The island is also linked to Thailand’s mainland by road.<br><br>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.<p>",
    cn:
      "<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",
    ru:
      "<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"
  }
};

export default {
  landingPage,
  map,
  content
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/destination.js